import React from 'react';
import { SecondMenu } from '../../../models/second-menu.entity';
import { TaxGroup } from '../../../models/tax-group.entity';
import MenuListComponent, { ContextMenuKey, MenuListItem } from '../menu-list/menu-list-component';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import _ from 'lodash';
import { FirstMenu } from '../../../models/first-menu.entity';
import { apiManage_rbp } from '../../../request';
import { Box, Button, Grid } from '@mui/material';
import ExtraCostFirstMenuSetting from './extra-cost-first-menu';
import ExtraCostDetail from './extra-cost-detail.component';
import DialogComponent from '../../../component/dialog/dialog.component';
import CommonInput from '../../../component/form/common-input.component';
// SCSS
import '../extra-cost/scss/extra-cost.style.scss';
import setLoading from '../../../component/linear-determinate';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';
import ButtonComponent from '../../../component/button/button.component';


/**
 * 额外费用组件
 */
class ExtraCostComponent extends React.Component<Props, State> {

    public state: State = {
        // 菜单数据
        menuData: [],
        // 删除二次确认弹窗
        deleteOpen: false,
        // 税率组列表
        taxGroup: [],
        // 加载中 初次加载时候使用
        isLoading: false,
        // 二级菜单弹窗
        isShowCreateMenuDialog: false,
        // 二级菜单名称
        newMenuValue: '',
        // 打印组(岗位)
        printGroup: [],
    }

    constructor(props: Props) {
        super(props);
        this.getMenuData = this.getMenuData.bind(this);
    }
    // *********************
    // Life Cycle Function
    // *********************

    public async componentDidMount() {
        this.setState({
            isLoading: true
        }, async () => {
            await this.init();
            await this.patchSecondMenuIndex()
        })

    }

    // *********************
    // Default Function
    // *********************

    // 初始化
    public async init() {
        try {
            setLoading(true);
            const taxResult = await this.getTaxGroup()
            const extraResult = await this.getMenuData();
            const printGroup = await this.getPrintClass();
            // 根据index重新排序额外费用二级菜单
            const curMenuSlu: SecondMenu[] = _.get(extraResult, '[0].menu_item_slu') || [];
            if (curMenuSlu.length > 0) {
                curMenuSlu.sort((a, b) => {
                    return Number(a?.dmi_slu_index) - Number(b?.dmi_slu_index)
                })
            }
            this.setState({
                activeMenuIndex: extraResult.length > 0 ? '[0]' : '',
                taxGroup: taxResult,
                printGroup,
                menuData: curMenuSlu,
                firstMenuId: _.get(extraResult, '[0].main_group_id'),
                isLoading: false
            })
            setLoading(false);
        } catch (error) {
            // setLinearLoading(false);
            this.setState({
                isLoading: false
            })
            setLoading(false);
        }
    }

    /**
     * 没有下标 自动修改下标
     */
    async patchSecondMenuIndex() {
        const { menuData } = this.state;
        let hasIndex = true;
        const menuIndexArr = menuData.map((item, index) => {
            // 判断是否有下标
            if (!(item.dmi_slu_index || (item.dmi_slu_index === 0))) {
                hasIndex = false;
            }
            return ({
                dmi_slu_id: item.dmi_slu_id,
                dmi_slu_index: index + 1
            })
        });
        // 如果没有下标
        if (!hasIndex) {
            // 修改下标
            await apiManage_rbp.patch_change_second_menu_index(menuIndexArr)
            const extraResult = await this.getMenuData();
            this.setState({
                menuData: _.get(extraResult, '[0].menu_item_slu') || [],
                firstMenuId: _.get(extraResult, '[0].main_group_id'),
            })
        }
    }

    /**
     * 获取税率组列表
     */
    public async getTaxGroup() {
        const result = await apiManage_rbp.get_tax_group();
        if (!_.get(result, 'error')) {
            return result
        }
        return []
    }

    /**
     * 获取打印组列表 （对应KWA岗位）
     */
    public async getPrintClass() {
        const result = await apiManage_rbp.getPrinterClass();
        if (!_.get(result, 'error')) {
            return result
        }
    }

    /**
     * 获取额外费用菜单
     */
    public async getMenuData() {
        // 获取额外费用
        const extraResult = await apiManage_rbp.get_menus_v3({
            type: 1,
            with_dish: true,
        });

        if (!_.get(extraResult, 'error')) {
            return extraResult
        }
        return []
    }


    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    handleClick(menuData: MenuListItem, index: string) {
        this.setState({
            activeMenuIndex: ''
        }, () => {
            this.setState({
                activeMenuIndex: index
            })
        })
    }

    /**
     * 右键点击事件处理
     * @param menu
     * @param index
     * @param key
     */
    handleMenuClick(key: ContextMenuKey, menu: MenuListItem, index: number) {
        this.setState({
            activeContextMenu: menu && menu.dataSource
        })

        switch (key) {
            // 新增同级
            case 'ADD': {
                this.setState({ isShowCreateMenuDialog: true })
                return;
            }
            // 删除同级
            case 'DELETE': {
                this.handleDeleteSecondMenu( )
                return;
            }
            // 下移菜单
            case 'DOWN': {
                this.handleUpdateMenuIndex(menu, index, 'DOWN')
                return;
            }
            // 上移菜单
            case 'UP': {
                this.handleUpdateMenuIndex(menu, index, 'UP')
                return;
            }
        }
    }


    /**
     * 新增一级菜单
     * @param menu
     */
    async handleAddFirstMenu() {
        let firstMenuId;
        const newFirstMenu: FirstMenu = {
            main_group_name: i18n.t('extra_cost_page_label'),
            menu_item_slu: [],
            main_group_index: 0
        }
        const result = await apiManage_rbp.post_create_first_menu(newFirstMenu)
        if (!_.get(result, 'error')) {
            // 设置成额外费用
            const settingResult = await apiManage_rbp.patch_settings_1(result.insertId);
            // 设置成功
            if (!_.get(settingResult, 'error')) {
                firstMenuId = result.insertId
            }
        }
        return firstMenuId
    }

    /**
     * 新增二级菜单
     */
    async handleAddSecondMenu() {
        const { activeContextMenu, newMenuValue } = this.state
        if (!newMenuValue.trim()) {
            GlobalNotification.error(i18n.t('staff_setting_page_enter_type_name'))
            return
        }
        // setLinearLoading(true);
        // 没有一级菜单id就新增
        console.log(this.state.firstMenuId, 'firstMenuIdfirstMenuId');
        const firstMenuId = this.state.firstMenuId || await this.handleAddFirstMenu();
        console.log(activeContextMenu, 'activeContextMenu');
        // 当前二级菜单下标
        const dataSource = activeContextMenu;
        const newSecondMenu: SecondMenu = {
            dmi_slu_name: newMenuValue,
            dmi_slu_index: Number(dataSource?.dmi_slu_index) + 1,
        }
        if (firstMenuId || firstMenuId === 0) {
            const result = await apiManage_rbp.post_create_second_menu(firstMenuId, newSecondMenu);
            console.log(result, 'result');
            if (!_.get(result, 'error')) {
                // 提示
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const extraResult = await this.getMenuData();
                const { curMenuSlu, curActiveIndex } = this.getSortedMenuDataAndIndex(extraResult, result.insertId);
                this.setState({
                    activeMenuIndex: ''
                }, () => {
                    this.setState({
                        activeMenuIndex: `[${curActiveIndex}]`,
                        menuData: curMenuSlu,
                        firstMenuId: _.get(extraResult, '[0].main_group_id'),
                        isShowCreateMenuDialog: false,
                        newMenuValue: ''
                    })
                })
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        }
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * 获取排序后的二级菜单数据和当前修改的索引
     * @param firstMenu 一级菜单数据
     * @param curInsertId 当前新增的二级菜单ID
     * @returns
     */
    getSortedMenuDataAndIndex(firstMenu: FirstMenu[], curInsertId?: number) {
        // 根据index重新排序额外费用二级菜单
        const curMenuSlu: SecondMenu[] = _.get(firstMenu, '[0].menu_item_slu') || [];
        if (curMenuSlu.length > 0) {
            curMenuSlu.sort((a, b) => {
                return Number(a?.dmi_slu_index) - Number(b?.dmi_slu_index)
            })
        }
        // 定位到当前新增的二级菜单的索引
        const curActiveIndex = curMenuSlu.findIndex(menuItem => menuItem.dmi_slu_id === curInsertId);
        return {
            curMenuSlu,
            curActiveIndex
        }
    }

    /**
     * 删除二级菜单
     * @param menu
     * @param index
     */
    handleDeleteSecondMenu() {
        this.setState({
            deleteOpen: true
        })

    }

    /**
     * 删除二级菜单
     */
    async deleteSecondMenu() {
        const { firstMenuId, activeContextMenu } = this.state;
        //  发起删除请求
        if (activeContextMenu && (activeContextMenu.menu_item || []).length === 0) {
            const result = await apiManage_rbp.delete_second_menu(activeContextMenu.dmi_slu_id as number, firstMenuId as number)
            if (!_.get(result, 'error')) {
                // 刷新数据
                const extraResult = await this.getMenuData();
                // 获取排序后的二级菜单列表
                const { curMenuSlu } = this.getSortedMenuDataAndIndex(extraResult);
                this.setState({
                    menuData: curMenuSlu,
                    firstMenuId: _.get(extraResult, '[0].main_group_id'),
                })

                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        }
        else if (activeContextMenu && (activeContextMenu.menu_item || []).length > 0) {
            GlobalNotification.warning(i18n.t('tax_group_page_current_node_have_sub_node_delete_sub_node_in_advance'))
        }

    }

    /**
     * 调整菜单顺序
     */
    async handleUpdateMenuIndex(menu: MenuListItem, index: number, key: 'UP' | 'DOWN') {
        // setLinearLoading(true)
        let newIndex = '';
        const { menuData } = this.state;
        const params = menuData.map((item) => ({
            dmi_slu_id: item.dmi_slu_id,
            dmi_slu_index: item.dmi_slu_index,
        }));
        // 下移
        if (key === 'DOWN') {
            [params[index]['dmi_slu_index'], params[index + 1]['dmi_slu_index']] =
                [params[index + 1]['dmi_slu_index'], params[index]['dmi_slu_index']];
            newIndex = `[${index + 1}]`;
        }
        // 上移
        else {
            [params[index]['dmi_slu_index'], params[index - 1]['dmi_slu_index']] =
                [params[index - 1]['dmi_slu_index'], params[index]['dmi_slu_index']];
            newIndex = `[${index - 1}]`;
        }

        //  发起请求
        const result = await apiManage_rbp.patch_change_second_menu_index(params)
        if (!_.get(result, 'error')) {
            // 刷新数据
            const extraResult = await this.getMenuData();
            // 根据index重新排序额外费用二级菜单
            let curMenuSlu: SecondMenu[] = _.get(extraResult, '[0].menu_item_slu') || [];
            if (curMenuSlu.length > 0) {
                curMenuSlu = curMenuSlu.sort((a, b) => {
                    return Number(a?.dmi_slu_index) - Number(b?.dmi_slu_index)
                })
            }
            this.setState({
                activeMenuIndex: '',
            }, () => {
                this.setState({
                    activeMenuIndex: newIndex,
                    menuData: curMenuSlu,
                    firstMenuId: _.get(extraResult, '[0].main_group_id'),
                })
            })
            GlobalNotification.success(i18n.t('global_text_operate_success'))
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
        // setLinearLoading(false)

    }

    public afterUpdateFirstMenu = async () => {
        await this.init()
    }

    // *********************
    // View
    // *********************

    render() {
        const { isLoading, menuData, activeMenuIndex, deleteOpen, taxGroup, printGroup, isShowCreateMenuDialog } = this.state;
        const activeMenu = activeMenuIndex ? _.get(menuData, activeMenuIndex) : undefined
        // 左侧菜单
        const menu = menuData.map((item) => ({
            key: `${item.dmi_slu_id}`,
            title: item.dmi_slu_name ?? '',
            dataSource: item,
        }));
        return (
            <Box hidden={isLoading}>
                <ExtraCostFirstMenuSetting afterOnSave={this.afterUpdateFirstMenu} />
                <Grid container spacing={6} style={{ marginTop: 0 }}>
                    <Grid item>
                        {/* 菜单列表 */}
                        <MenuListComponent
                            activeMenu={activeMenu ? `${activeMenu.dmi_slu_id}` : undefined}
                            menu={menu}
                            handleClick={(menuData, index) => { this.handleClick(menuData, index) }}
                            handleMenuClick={(key, menu, index) => {
                                this.handleMenuClick(key, menu, index)
                            }}
                        />
                    </Grid>
                    <Grid item xs>
                        {
                            activeMenu &&
                            <ExtraCostDetail
                                taxGroup={taxGroup}
                                printGroup={printGroup}
                                detail={activeMenu}
                                updateMenuData={async () => {
                                    const extraResult = await this.getMenuData();
                                    // 获取排序后的菜单数据
                                    const { curMenuSlu } = this.getSortedMenuDataAndIndex(extraResult || []);
                                    this.setState({
                                        menuData: curMenuSlu || [],
                                        firstMenuId: _.get(extraResult, '[0].main_group_id'),
                                    })
                                }}
                            />
                        }
                    </Grid>
                </Grid>
                {
                    <DialogComponent
                        open={isShowCreateMenuDialog}
                        defaultHeaderProps={{
                            title: i18n.t('global_text_name'),
                            onClose: () => {
                                this.setState({
                                    isShowCreateMenuDialog: false
                                })
                            }
                        }}
                        fullWidth={true}
                        maxWidth={'xs'}
                        footer={
                            <div>
                                <Button
                                    color='primary'
                                    variant='outlined'
                                    onClick={() => {
                                        this.setState({
                                            isShowCreateMenuDialog: false
                                        })
                                    }}
                                >{i18n.t('google_text_public_button_cancel')}</Button>
                                <Box marginLeft={4} display='inline-block'>
                                    <ButtonComponent
                                        variant='contained'
                                        handleClick={async () => {
                                            await this.handleAddSecondMenu()
                                        }}
                                    >
                                        {i18n.t('google_text_confirm')}
                                    </ButtonComponent>
                                </Box>
                            </div>}
                    >
                        <CommonInput
                            label={i18n.t('global_text_name')}
                            required={true}
                            regularType={'required'}
                            variant={'outlined'}
                            fullWidth
                            value={this.state.newMenuValue as any}
                            onChange={(event: any) => {
                                const value = event.currentTarget.value
                                this.setState({
                                    newMenuValue: value,
                                })
                            }}
                        />
                    </DialogComponent>
                }
                {
                    deleteOpen &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('tax_group_page_delete_menu'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                            onConfirm: async () => {
                                await this.deleteSecondMenu()
                                this.setState({
                                    deleteOpen: false
                                })
                            },
                        }}
                    />
                }
            </Box>
        )
    }
}

export default ExtraCostComponent;

// *********************
// Type
// *********************
type Props = {}
type State = {
    // 菜单数据
    menuData: SecondMenu[];
    // 当前选中菜单的索引
    activeMenuIndex?: string;
    // 额外费用id
    firstMenuId?: number;
    // 删除二次确认弹窗
    deleteOpen: boolean;
    // 右键选中的二级菜单
    activeContextMenu?: SecondMenu;
    // 税率组列表
    taxGroup: TaxGroup[];
    // 加载中 初次加载时候使用
    isLoading: boolean;
    // 新增二级菜单弹窗
    isShowCreateMenuDialog: boolean;
    // 新增二级菜单名称
    newMenuValue: string;
    // 打印组(岗位)
    printGroup: any[];
}